if (typeof window !== 'undefined') {
      window.g_rootExports = {};
    }